import { motion } from "framer-motion"

export const Check = (props: any) => {
  return (
    <svg {...props} aria-hidden="true" role="presentation" viewBox="0 0 17 18">
      <motion.polyline
        animate={{
          pathLength: [0, 1],
        }}
        transition={{
          duration: .5,
          ease: "easeInOut",
          times: [0, 0.5,],
        }}

        fill="none" points="1 9 7 14 15 4" stroke="currentColor" strokeDasharray="22" strokeDashoffset="44" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
      </motion.polyline>
    </svg>
  )
}